import React, { useState, useRef, useMemo } from 'react';
import { Link } from 'react-router-dom';
import '../styles/l33t.css';
import CyberInterface from './CyberInterface';
import DecryptModal from './DecryptModal';
import DebugRealityModal from './DebugRealityModal';
import SimulationWatchModal from './SimulationWatchModal';
import YaldabaothModal from './YaldabaothModal';
import CyberFooter from './CyberFooter';

const HOLOSCREEN_BACKGROUNDS = [
  '/assets/images/l33t/holoscreens01.jpg',
  '/assets/images/l33t/holoscreens02.jpg',
  '/assets/images/l33t/holoscreens03.jpg',
  '/assets/images/l33t/holoscreens04.jpg',
];

const L33tPage = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDebugModalOpen, setIsDebugModalOpen] = useState(false);
  const [isWatchModalOpen, setIsWatchModalOpen] = useState(false);
  const [isYaldabaothModalOpen, setIsYaldabaothModalOpen] = useState(false);
  const terminalRef = useRef(null);
  
  // Select a random background on component mount
  const randomBackground = useMemo(() => {
    const randomIndex = Math.floor(Math.random() * HOLOSCREEN_BACKGROUNDS.length);
    return HOLOSCREEN_BACKGROUNDS[randomIndex];
  }, []);

  const scrollToTerminal = () => {
    terminalRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <div className="l33t-page min-h-screen bg-purple-950">
      {/* Navigation */}
      <nav className="l33t-nav fixed top-0 w-full z-50 bg-[#1a0933]/90 backdrop-blur-sm border-b border-[#39ff14]/30">
        <div className="container mx-auto px-4 py-3 flex items-center justify-between">
          <Link to="/" className="text-[#39ff14] text-2xl font-['VT323'] hover:text-[#39ff14]/80 transition-colors">
            0MN1G315T.exe
          </Link>
          <div className="flex items-center space-x-6">
            <Link to="/product" className="text-[#39ff14] hover:text-[#39ff14]/80 transition-colors">PRODUCT</Link>
            <Link to="/services" className="text-[#39ff14] hover:text-[#39ff14]/80 transition-colors">SERVICES</Link>
            <Link to="/about" className="text-[#39ff14] hover:text-[#39ff14]/80 transition-colors">ABOUT</Link>
            <Link to="/contact" className="text-[#39ff14] hover:text-[#39ff14]/80 transition-colors">CONTACT</Link>
          </div>
        </div>
        <div className="scanline"></div>
      </nav>

      {/* Hero Section */}
      <section className="l33t-hero h-screen flex items-center justify-center relative overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-30"
          style={{ backgroundImage: `url(${randomBackground})` }}
        />
        <div className="matrix-bg"></div>
        <div className="container mx-auto px-4 text-center relative z-10">
          <h1 className="glitch-title text-7xl mb-8" data-text="UNLEASH YOUR STORY.exe">
            UNLEASH YOUR STORY.exe
            <span aria-hidden="true"></span>
          </h1>
          <p className="cyber-text text-cyan-400 text-xl mb-12">
            &gt; INITIALIZING NARRATIVE PROTOCOLS_
          </p>
          <div className="flex gap-6 justify-center">
            <button 
              onClick={scrollToTerminal}
              className="crt-button bg-transparent text-[#39ff14] border-2 border-[#39ff14] px-8 py-4 text-xl hover:bg-[#39ff14]/10 transition-all relative group"
            >
              <span className="relative z-10">INITIATE_SEQUENCE</span>
              <div className="absolute inset-0 bg-gradient-to-r from-[#39ff14]/0 via-[#39ff14]/10 to-[#39ff14]/0 opacity-0 group-hover:opacity-100 transition-opacity"></div>
            </button>
            <button 
              onClick={() => setIsModalOpen(true)}
              className="crt-button bg-transparent text-cyan-400 border-2 border-cyan-400 px-8 py-4 text-xl hover:bg-cyan-400/10 transition-all relative group"
            >
              <span className="relative z-10">DECRYPT_DATA</span>
              <div className="absolute inset-0 bg-gradient-to-r from-cyan-400/0 via-cyan-400/10 to-cyan-400/0 opacity-0 group-hover:opacity-100 transition-opacity"></div>
            </button>
          </div>
        </div>
      </section>

      {/* Terminal Section */}
      <section ref={terminalRef} className="py-20 relative overflow-hidden">
        <div className="absolute inset-0 z-0">
          <img src="/assets/svg/L33tBackground.svg" alt="" className="w-full h-full object-cover glitch-background" />
          <div className="vhs-effect"></div>
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-purple-950/70 to-purple-950/30 z-0"></div>
        <div className="container mx-auto px-4 relative z-10">
          <h2 
            className="cyber-heading text-4xl mb-12 text-center text-[#39ff14] glitch"
            data-text="OMNIGEIST NARRATIVE SIMULATION DESIGNER v1.0"
          >
            OMNIGEIST NARRATIVE SIMULATION DESIGNER v1.0
          </h2>
          <div className="flex flex-col gap-12">
            <div className="terminal-card p-8 bg-purple-900/90 h-[800px] rounded-lg border-2 border-[#39ff14]">
              <div className="h-full font-mono text-sm">
                <CyberInterface 
                  isVisible={true} 
                  onDebugClick={() => setIsDebugModalOpen(true)}
                  onWatchClick={() => setIsWatchModalOpen(true)}
                  onYaldabaothClick={() => setIsYaldabaothModalOpen(true)}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Modals */}
      <DecryptModal 
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
      <DebugRealityModal
        isOpen={isDebugModalOpen}
        onClose={() => setIsDebugModalOpen(false)}
      />
      <SimulationWatchModal 
        isOpen={isWatchModalOpen}
        onClose={() => setIsWatchModalOpen(false)}
      />
      <YaldabaothModal
        isOpen={isYaldabaothModalOpen}
        onClose={() => setIsYaldabaothModalOpen(false)}
      />

      {/* Cyberpunk Footer */}
      <CyberFooter />
    </div>
  );
};

export default L33tPage;
